module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "classify"
  }, [_c('div', {
    staticClass: "tableConBox"
  }, [_c('div', {
    staticClass: "tableTem"
  }, [_c('div', {
    staticClass: "HSpace1"
  }), _vm._v(" "), _c('div', {
    staticClass: "searchBox flex flex-align-center"
  }, [_c('div', {
    staticClass: "clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "left search flex flex-align-center"
  }, [_vm._v("\n                        机位设置\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "right searchBtn"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addClassify(false)
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  }), _vm._v("新增")])])])]), _vm._v(" "), _c('div', {
    staticClass: "HSpace2"
  }), _vm._v(" "), _c('div', {
    staticClass: "tableBox"
  }, [_c('div', {
    staticClass: "tableBoxScroll"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "scrollBox"
  }, [_c('div', {
    staticClass: "scroll"
  }, [_c('div', {
    staticClass: "type_parent"
  }, _vm._l((_vm.typeData), function(item, ind) {
    return _c('div', {
      staticClass: "type_parent_item type_active",
      style: ({
        height: (item.isOpen && _vm.btn ? ((item.children.length + 1) * 9 + '%') : '9%')
      })
    }, [_c('div', {
      staticClass: "type_parent_text clearfix",
      style: ({
        height: (item.isOpen && _vm.btn ? (100 / (item.children.length + 1) + '%') : '100%')
      })
    }, [_c('div', {
      staticClass: "left type_parent_text_left flex flex-align-center",
      on: {
        "click": function($event) {
          return _vm.handle(item, ind)
        }
      }
    }, [_c('i', {
      staticClass: "i",
      class: {
        'el-icon-caret-right': item.children.length && (!item.isOpen || !_vm.btn),
        'el-icon-caret-bottom': item.children.length && (!item.isOpen || _vm.btn)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "parent_default type_name",
      domProps: {
        "textContent": _vm._s(item.name)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right ss flex flex-align-center flex-pack-center"
    }), _vm._v(" "), _c('span', {
      staticClass: "right type_parent_text_right flex flex-align-center flex-pack-center",
      staticStyle: {
        "width": "120px",
        "display": "flex"
      }
    }, [_c('span', {
      staticClass: "left",
      staticStyle: {
        "font-size": "14px",
        "white-space": "nowrap",
        "width": "150px"
      }
    }, [_vm._v("排序值：" + _vm._s(item.queue))]), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-icon02",
      staticStyle: {
        "padding-left": "50px"
      },
      attrs: {
        "title": "添加"
      },
      on: {
        "click": function($event) {
          return _vm.addSiteBatch(item)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-bianji",
      attrs: {
        "title": "修改"
      },
      on: {
        "click": function($event) {
          return _vm.upClassify(item, false)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "iconfont icon-icon1460188478041",
      attrs: {
        "title": "删除"
      },
      on: {
        "click": function($event) {
          return _vm.delClassify(item, false)
        }
      }
    })])]), _vm._v(" "), (item.isOpen && _vm.btn) ? _c('div', {
      staticClass: "type_child",
      style: ({
        height: (100 - 100 / (item.children.length + 1) + '%')
      })
    }, _vm._l((item.children), function(oitem, oInd) {
      return _c('div', {
        staticClass: "type_child_item",
        style: ({
          height: (100 / (item.children.length) + '%')
        })
      }, [_c('div', {
        staticClass: "type_child_left left flex flex-align-center"
      }, [_c('span', {
        staticClass: "left",
        domProps: {
          "textContent": _vm._s(oitem.name)
        }
      })]), _vm._v(" "), _c('span', {
        staticStyle: {
          "display": "flex",
          "margin-right": "170px"
        }
      }, [_c('span', {
        staticClass: "left",
        staticStyle: {
          "font-size": "14px",
          "padding-right": "100px",
          "white-space": "nowrap"
        }
      }, [_vm._v("IP地址：" + _vm._s(oitem.ipAddress))]), _vm._v(" "), _c('span', {
        staticClass: "right type_parent_text_right flex flex-align-center flex-pack-center"
      }, [_c('i', {
        staticClass: "iconfont icon-bianji",
        staticStyle: {
          "padding-right": "10px",
          "cursor": "pointer"
        },
        attrs: {
          "title": "修改"
        },
        on: {
          "click": function($event) {
            return _vm.modifySite(item, oitem)
          }
        }
      }), _vm._v(" "), _c('i', {
        staticClass: "iconfont icon-icon1460188478041",
        staticStyle: {
          "padding-right": "10px",
          "cursor": "pointer"
        },
        attrs: {
          "title": "删除"
        },
        on: {
          "click": function($event) {
            return _vm.delSite(item, oitem)
          }
        }
      })])])])
    }), 0) : _vm._e()])
  }), 0)])])])])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "添加/编辑",
      "visible": _vm.addJobVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.addJobVisible = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("区域名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.name),
      expression: "obj.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入名称"
    },
    domProps: {
      "value": (_vm.obj.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v("排序值")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.obj.queue),
      expression: "obj.queue"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "number",
      "placeholder": "请输入名称"
    },
    domProps: {
      "value": (_vm.obj.queue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.obj, "queue", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addJobVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addDiscount
    }
  }, [_vm._v("保存")])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "批量添加机位",
      "visible": _vm.showModifySiteBatch
    },
    on: {
      "update:visible": function($event) {
        _vm.showModifySiteBatch = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("起始IP地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBatchSite.beginIp),
      expression: "newBatchSite.beginIp"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "如：192.168.1.1"
    },
    domProps: {
      "value": (_vm.newBatchSite.beginIp)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBatchSite, "beginIp", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "110px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("生成机位数量")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newBatchSite.count),
      expression: "newBatchSite.count"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "number",
      "placeholder": "如:50"
    },
    domProps: {
      "value": (_vm.newBatchSite.count)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newBatchSite, "count", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModifySiteBatch = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doAddNewSiteBatch
    }
  }, [_vm._v("生成")])])]), _vm._v(" "), _c('el-dialog', {
    staticClass: "dialog",
    attrs: {
      "title": "添加/编辑机位",
      "visible": _vm.showModifySite
    },
    on: {
      "update:visible": function($event) {
        _vm.showModifySite = $event
      }
    }
  }, [_c('div', [_c('div', {
    staticClass: "msgBox clearfix"
  }, [_c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("机位名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSite.name),
      expression: "newSite.name"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.newSite.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newSite, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "left msgItem clearfix",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "left itemName",
    staticStyle: {
      "width": "100px"
    }
  }, [_c('i', [_vm._v("*")]), _vm._v("IP地址")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newSite.ipAddress),
      expression: "newSite.ipAddress"
    }],
    staticClass: "left itemInput",
    attrs: {
      "type": "text",
      "placeholder": "请输入"
    },
    domProps: {
      "value": (_vm.newSite.ipAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newSite, "ipAddress", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModifySite = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doAddNewSite
    }
  }, [_vm._v("保存")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "titleTable"
  }, [_c('tr', [_c('th', [_vm._v("区域名称")]), _vm._v(" "), _c('th', [_vm._v("操作")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-11fc064b","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/computer/region.vue
// module id = 923
// module chunks = 1